import { ListSubheader } from '@mui/material'
import { type EnhancedDomain } from 'higgins-domain'
import { type MouseEventHandler, useCallback, useState } from 'react'

import { SceneFab } from '@salsita-ai/platform-project-sdk/configurator'
import { useResolveLocalizable } from '@salsita-ai/platform-project-sdk/react'
import { PhxIcon, RecipeMenuItem, ResponsiveMenu } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../systems/configurator-interface'

const ReplaceEntityMenu = (props: {
  anchorEl: HTMLButtonElement
  open: boolean
  onClose: () => void
  entityId: EnhancedDomain.$Segment['id']
}) => {
  const { entityId, open, onClose, anchorEl } = props
  const recipeOptions = configuratorInterface.useReplaceEntityRecipeOptions(entityId)

  const resolveLocalizable = useResolveLocalizable()

  return (
    <ResponsiveMenu open={open} anchorEl={anchorEl} onClose={onClose} closeLabel="Close">
      <ListSubheader>Replace with compatible item</ListSubheader>
      {recipeOptions.flatMap(recipeGroup =>
        recipeGroup.recipes.map((recipe, index) => (
          <RecipeMenuItem
            key={index}
            title={resolveLocalizable(recipe.title)}
            tooltipTitle={recipe.tooltipTitle}
            disabled={recipe.disabled}
            thumbnailUrl={resolveLocalizable(recipe.thumbnailUrl)}
            onClick={recipe.handleClick}
            description={resolveLocalizable(recipe.description)}
            onDebugClick={recipe.trace}
          />
        ))
      )}
    </ResponsiveMenu>
  )
}

export const ReplaceButton = (props: { entityId: EnhancedDomain.$Segment['id'] }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null)
  const menuOpen = anchorEl !== null

  const handleOpen = useCallback<MouseEventHandler<HTMLButtonElement>>(event => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <>
      <SceneFab
        icon={<PhxIcon name="ArrowClockwise" />}
        title="Replace with compatible item"
        size="small"
        color="primary"
        onClick={handleOpen}
      />
      {menuOpen && (
        <ReplaceEntityMenu anchorEl={anchorEl} open={menuOpen} onClose={handleClose} entityId={props.entityId} />
      )}
    </>
  )
}
